export default {
  headers: [
    {
      text: 'ID',
      value: 'id',
    },
    {
      text: 'Name',
      value: 'displayName',
    },
    {
      text: 'Email',
      value: 'email',
    },
    {
      text: 'Phone Number',
      value: 'phoneNumber',
    },
    {
      text: 'Roles',
      value: 'roles',
    },
    {
      text: 'Email Verified',
      value: 'emailVerified',
    },
    {
      text: 'Actions',
      value: 'actions',
      sort: false,
      align: 'center',
    },
  ],
  options: {
    loadingText: 'Loading users... Please wait',
    showSelect: true,
    itemsPerPage: 10,
  },
  bulkActionItems: [{
    title: 'Manage Roles',
    id: 'roleChangeMultiple',
    action: 'onMulitpleRoleChange',
  }],
  actionItems: [{
    title: 'Manage Roles',
    id: 'roleChange',
    action: 'onRoleChange',
  }],
};
